module.exports = __webpack_public_path__ + "static/img/ico-original.b639e55.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/bancos/ico-original.png
// module id = Qj3b
// module chunks = 0